var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"violations-modal__event-tip"},[_c('div',{staticClass:"violations-modal__event-tip__mark"}),_c('r-text',[_vm._v(" Поля со знаком были импортированы из Редактора ОДД ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }